export function emitMessage(eventName, channel, message) {
  return {
    type: 'WS_EMIT',
    payload: { eventName, channel, message },
  };
}

export function joinChannel(channel) {
  return {
    type: 'WS_JOIN',
    payload: { channel },
  };
}

export function leaveChannel(channel) {
  return {
    type: 'WS_LEAVE',
    payload: { channel },
  };
}



// WEBPACK FOOTER //
// ./app/actions/ws-actions.js